// Publicar un avance y avisarle al cliente son DOS HECHOS DISTINTOS.
//
// ┌─ POR QUE ESTE ARCHIVO EXISTE ────────────────────────────────────────────────┐
// │ `publishProjectUpdateToClient` avisaba al CRM y al equipo, y NUNCA al        │
// │ cliente. El correo existe y tiene renderizador —`project_approval_ready_     │
// │ email`— pero salia por `advanceClientPhase`, es decir por una transicion de  │
// │ FASE del CRM: publicar en Kanban no mueve la fase, asi que no salia nada.    │
// │ El cliente solo se enteraba si entraba al portal por su cuenta.              │
// └──────────────────────────────────────────────────────────────────────────────┘
//
// ⚠️ DECISION DE PRODUCTO (David, 2026-08-09): publicar un avance **NO** mueve la fase del
// CRM. «Publicamos un avance» ≠ «el proyecto esta listo para aprobacion» ≠ «avanzamos la
// fase comercial». Acoplarlos para conseguir un correo seria volver al patron que estamos
// sacando de Feria OS: un hecho disparando la representacion de otro.
// Por eso el aviso se emite DIRECTO, con su propia clave de evento, sin tocar el CRM.
//
// La plantilla se reutiliza porque describe EL EVENTO, no la fase: «la propuesta ya esta
// disponible para revision final; ingresa al portal para aprobarla o dejar ajustes».
// Eso es exactamente lo que pasa cuando el staff publica un avance para el cliente.

import { ESTADOS_DE_ENVIO_ACEPTADOS } from './communications';

export const PLANTILLA_AVISO_DE_AVANCE = 'project_approval_ready_email';

// ── IDEMPOTENCIA ─────────────────────────────────────────────────────────────────────
// `communication_events` NO tiene restriccion unica sobre `event_key` (verificado en los
// indices de la BD el 2026-08-10 UTC) y `dispatch-critical-communication` no deduplica:
// dos llamadas con la misma clave son dos correos. La proteccion vive aca, en el llamador.
//
// La llave natural es el `id` del avance: estable, y un avance se publica UNA vez.
export function claveDeAvisoDeAvance(updateId) {
  const id = String(updateId || '').trim();
  return id ? `project_update_published_${id}` : '';
}

// ¿Un intento previo con esta clave ya llego a destino? Usa la MISMA lista de estados
// aceptados que el despachador — importada, no copiada.
export function yaSeAviso(eventoPrevio) {
  if (!eventoPrevio) return false;
  return ESTADOS_DE_ENVIO_ACEPTADOS.includes(String(eventoPrevio.status || '').toLowerCase());
}

// 'enviar'     → hay a quien escribirle y no se le escribio todavia
// 'ya_avisado' → un intento anterior con la misma clave llego; reintentar seria un duplicado
// 'sin_correo' → no hay destinatario; NO es un fallo del envio, es una ausencia de dato
export function decidirAvisoDeAvance({ correoCliente, eventoPrevio } = {}) {
  if (!String(correoCliente || '').trim()) return 'sin_correo';
  return yaSeAviso(eventoPrevio) ? 'ya_avisado' : 'enviar';
}

// ── LA UI DICE LA VERDAD DE LOS DOS HECHOS ───────────────────────────────────────────
// Nunca «publicado y notificado» cuando lo unico que sabemos es que el UPDATE del avance
// funciono. Y un correo caido NO revierte una publicacion valida: el avance ESTA en el
// portal, eso es cierto y se dice.
//
// El caso C —la publicacion fallo— no pasa por aca a proposito: si no hubo publicacion no
// se afirma nada sobre el aviso, y el error sube por su propio camino.
const AVISOS = {
  enviado:    { texto: 'Avance publicado. Le avisamos al cliente por correo.', tono: '✓' },
  ya_avisado: { texto: 'Avance publicado. Al cliente ya se le habia avisado.', tono: '✓' },
  fallido:    { texto: 'Avance publicado, pero no pudimos avisarle al cliente. Escribile tú.', tono: '⚠' },
  sin_correo: { texto: 'Avance publicado. El cliente no tiene correo registrado, no se le avisó.', tono: '⚠' },
};

export function mensajeDePublicacion(estadoDelAviso) {
  return AVISOS[estadoDelAviso] || AVISOS.fallido;
}
